import { lazy, Suspense, useEffect, useMemo } from 'react'

import { LoadingTurbo } from 'atoms'
import { BUSINESS_CODE } from 'integration/resources/auth'
import { ListType } from 'src/screens/OrganizationScreen/OrganizationScreen.types'
import { useAuthAtomValue } from 'src/store/auth'

import { OpportunitiesListScreenComponent } from './OpportunitiesListScreen.types'
import { useOpportunitiesListScreen } from './useOpportunitiesListScreen'

const OpportunitiesListScreenDesktop = lazy(() => import('./OpportunitiesListScreen.desktop'))

export const OpportunitiesListScreen: OpportunitiesListScreenComponent = ({
  navigation,
  route
}) => {
  const authAtom = useAuthAtomValue()

  const isGoodsAndServices = useMemo(() => {
    return authAtom?.user.business_code === BUSINESS_CODE.GOODS_AND_SERVICES
  }, [authAtom?.user.business_code])

  const props = useOpportunitiesListScreen({ navigation, route })

  useEffect(() => {
    if (authAtom && isGoodsAndServices) {
      navigation.replace('OrganizationOpportunityList', { listType: ListType.ODC })
    }
  }, [authAtom, isGoodsAndServices, navigation])

  // Se for GoodsAndServices, mostrar loading enquanto redireciona
  if (isGoodsAndServices) {
    return <LoadingTurbo />
  }

  const Screen = OpportunitiesListScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
